module.exports = __webpack_public_path__ + "img/home4.ce5de57e.png";